import { UpdateCurrentUserReqData } from "@/model/communication/auth/UpdateCurrentUserReqData";
import { ClientProfile } from "./ClientProfile";
import { UserConfig } from "./UserConfig";

/**Rapresenta un utente in grado di autenticarsi attraverso un client per utilizzare la piattaforma */
export class ClientUser {
    /**Nome utente */
    name: string;
    /**Email */
    email: string;
    /**Profilo di utenza */
    profile: ClientProfile;
    userConfig: UserConfig;
    isWindowsLogin: boolean;
    isAuthPluginLogin: boolean;

    static parseFrom(data: any): ClientUser {
        let res = new ClientUser();
        res.name = data.Name;
        res.email = data.Email;

        if (data.Profile) {
            res.profile = ClientProfile.parseFrom(data.Profile);
        } else {
            res.profile = new ClientProfile();
        }

        res.userConfig = new UserConfig();
        if (data.UserConfig) {
            res.userConfig.fillFromJson(data.UserConfig);
        }

        res.isWindowsLogin = data.IsWindowsLogin;
        res.isAuthPluginLogin = data.IsAuthPluginLogin;
        return res;
    }

    canChangePassword() {
        return !this.isWindowsLogin && !this.isAuthPluginLogin;
    }

    createUpdateCurrentUserReqData(): UpdateCurrentUserReqData {
        let res = new UpdateCurrentUserReqData();
        res.email = this.email;
        res.userConfig = this.userConfig.clone();

        return res;
    }
}
